import { Component, Input, OnInit } from '@angular/core'
import { AppState } from 'src/app/core/core.state'
import { Store } from '@ngrx/store'
import { Actions } from '@ngrx/effects'
import { NotificationService } from 'src/app/core/notification.service'
import { Observable } from 'rxjs'
import { Router } from '@angular/router'
import { courseSelectors } from '../course.selectors'
import { BsModalRef } from 'ngx-bootstrap/modal'
import { Course } from '../course'
import { saleItemActions } from '../../sale/sale-item/sale-item.actions'
import { SaleItem } from '../../sale/sale-item/sale-item'
import moment from 'moment-mini'
import { productActions } from '../../product/product.actions'
import { RequestQueryBuilder } from '@nestjsx/crud-request'

@Component({
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class CreateCourseSaleModalComponent implements OnInit {
  @Input() customerPersonId: number
  @Input() customerCategory: number

  public isLoading$: Observable<boolean>

  constructor(
    private router: Router,
    private store: Store<AppState>,
    private actions$: Actions,
    private notificationService: NotificationService,
    private bsModalRef: BsModalRef
  ) {}

  ngOnInit() {
    this.isLoading$ = this.store.select(courseSelectors.selectIsLoading)
  }

  public onClickRow(course: Course) {
    if (course?.productId) {
      this.store.dispatch(
        productActions.fetchOneById({
          id: course?.productId,
          params: RequestQueryBuilder.create({
            join: [{ field: 'linkedSubscriptions' }]
          })
        })
      )
    }

    this.store.dispatch(
      saleItemActions.createOnePartial({
        entity: {
          ...new SaleItem(),
          subscriptionId: null,
          courseId: course.id,
          productId: course.productId,
          quantity: 1,
          bookingId: null,
          customerCategory: this.customerCategory,
          params: {
            invitedMemberEmails: [],
            invitedGuests: [],
            invitedOthers: [],
            startDate: moment(course.startDate).toISOString(),
            endDate: moment(course.endDate).toISOString()
          }
        }
      })
    )
    this.bsModalRef.hide()
  }
  public cancel() {
    this.bsModalRef.hide()
  }
}
